import React, { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthService from "../../Services/auth.service";
import LoaderContext from "../../Context/LoaderContext/Index";

const ProviderLoader = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const authService = AuthService.getInstance();
  const accessToken = searchParams.get("access_token");
  const { isLoading, setLoading } = useContext(LoaderContext);
  useEffect(() => {
    const storeAccessToken = async () => {
      setLoading(true);
      if (accessToken) {
        const res = await authService.signupProviderTokenVerification(
          accessToken
        );
        if (res) {
          setLoading(false);
          navigate("/");
        }
      }
    };
    try {
      storeAccessToken();
    } catch (error) {
      console.log("🚀 ~ useEffect ~ error:", error);
    } finally {
      setLoading(false);
    }
  }, [accessToken]);
  return <></>;
};

export default ProviderLoader;
